import React, { Component } from 'react';

import styles from './index.css';

class ErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = {
			hasError: false,
			info: {
				componentStack: '',
			},
		};
	}

	componentDidCatch(error, info) {
		this.setState({ hasError: true, info });
	}

	render() {
		if (this.state.hasError) {
			return (
				<div className={styles.errorBoundary}>
					<h3>OOPS! 有地方出錯了</h3>
					<div>{this.state.info.componentStack}</div>
				</div>
			);
		}
		return this.props.children;
	}
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/components/organisms/ErrorBoundary/index.js